import { reactive, toRefs } from "vue";
export default {
  props: {
    text: {
      type: String,
      default: ""
    }
  },

  setup(props) {
    const state = reactive({
      count: 0
    });
    return { ...toRefs(state)
    };
  }

};